import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { useController } from 'react-hook-form';

interface Props extends ChakraV3.TextareaProps {
  name: string;
}

export const HookedTextArea = (props: Props) => {
  const { name, defaultValue, ...rest } = props;

  const {
    field: { ref, ...inputProps },
  } = useController({ name, defaultValue });

  return <ChakraV3.Textarea {...rest} {...inputProps} value={inputProps.value ?? ''} />;
};
